import React, { Component } from 'react'
import moment from 'moment';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { withFormsy } from 'formsy-react';
import '../Textbox/DGTextbox.less';
import './DGDateTimePicker.less';
import { Icon } from 'semantic-ui-react';

var yesterday = moment().subtract(1, "day");
function valid(current) {
  return current.isAfter(yesterday);
}

const initialState = { calendarOpen: false };

class DGDateTimePicker extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    onChange = (selectedDate) => {
        this.props.setValue(selectedDate);
        if (this.props.onChange) {
            this.props.onChange(selectedDate);
        }

    }
    onInputClick = () => {
        this.setState({calendarOpen: true});
    }

    renderInput = ( props, openCalendar, closeCalendar ) => {
        function clear(){
            props.onChange({target: {value: ''}});
        }

        return (
            <div className="field">
                <input type='text' readOnly
                    tabIndex={this.props.tabIndex}
                    {...{
                        placeholder: this.props.placeholder ? this.props.placeholder : " ",
                        className: 'dgtext',
                        disabled: this.props.disabled
                    }}
                    
                    value={props.value}
                    onChange={props.onChange}
                    onClick={props.onClick}
                    onFocus={props.onFocus}
                    onKeyDown={props.onKeyDown}
                />
                <div className='label'><span>{this.props.label}</span>
                    {this.props.placeholder && <span> ({this.props.placeholder})</span>}
                    {!this.props.placeholder && <span></span>}
                </div>
                {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
                {this.props.showRequired &&
                    <div className="required">*</div>
                }

                {this.props.showLoader &&
                    <div className="loader"><img src={loader}></img></div>
                }

                {this.props.showresetbutton && props.value && props.value.length > 0 && 
                
                    <Icon onClick={clear} className='btn-reset' name='close' />
                }
            </div>
        );
    }

    render() {

        return (
            <Datetime className="dgdatetimepicker"
            isValidDate={valid} 
            onChange={this.onChange} 
            renderInput={this.renderInput}
            {...this.props}
            />
        );

    }
}

export default withFormsy(DGDateTimePicker)
